const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api-rest-6binventory-nodejs-test-qa.onrender.com';
const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT || '10000', 10);

const buildApiUrl = (endpoint) => {
  const baseUrl = API_BASE_URL.endsWith('/') 
    ? API_BASE_URL.slice(0, -1) 
    : API_BASE_URL;
  const cleanEndpoint = endpoint.startsWith('/') 
    ? endpoint.slice(1) 
    : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
};

export { API_BASE_URL, API_TIMEOUT, buildApiUrl };
